import { Union, Record } from "../fable_modules/fable-library-js.4.19.3/Types.js";
import { enum_type, int32_type, bool_type, tuple_type, lambda_type, unit_type, list_type, union_type, option_type, record_type, class_type, string_type } from "../fable_modules/fable-library-js.4.19.3/Reflection.js";
import { S3Context_$reflection } from "../Common/AwsCommon.js";
import { UploadSelection_$reflection, FileComponentSpecs_$reflection, FileManagementProgress_$reflection } from "./Shared.js";
import { FileData_$reflection } from "../Common/FileData.js";
import { FileOperationContext_$reflection, S3ObjectViewModel_$reflection } from "../RAWMap.Models/Api.js";
import { empty, singleton, append, delay, iterate } from "../fable_modules/fable-library-js.4.19.3/Seq.js";
import { toArray } from "../fable_modules/fable-library-js.4.19.3/Option.js";
import { iterate as iterate_1, contains, filter, length as length_1, concat, map, ofArray, sum } from "../fable_modules/fable-library-js.4.19.3/List.js";
import { toList, count } from "../fable_modules/fable-library-js.4.19.3/Map.js";
import { List_distinct } from "../fable_modules/fable-library-js.4.19.3/Seq2.js";
import { structuralHash, equals, arrayHash, equalArrays } from "../fable_modules/fable-library-js.4.19.3/Util.js";
import { ResultComputationExpression_result, ResultComputationExpression_ResultBuilder__Return_1505, ResultComputationExpression_ResultBuilder__Delay_1505, ResultComputationExpression_ResultBuilder__Run_FCFD9EF } from "../fable_modules/AsyncResult.0.3.0/Result.fs.js";

export class FileManagementUpdateArgs extends Record {
    constructor(Token, Credentials, Context) {
        super();
        this.Token = Token;
        this.Credentials = Credentials;
        this.Context = Context;
    }
}

export function FileManagementUpdateArgs_$reflection() {
    return record_type("RAWMap.Client.FileManagement.Types.FileManagementUpdateArgs", [], FileManagementUpdateArgs, () => [["Token", string_type], ["Credentials", class_type("Fable.Import.Aws.Credentials.Credentials")], ["Context", S3Context_$reflection()]]);
}

export class FileManagement extends Record {
    constructor(Name, Progress) {
        super();
        this.Name = Name;
        this.Progress = Progress;
    }
}

export function FileManagement_$reflection() {
    return record_type("RAWMap.Client.FileManagement.Types.FileManagement", [], FileManagement, () => [["Name", string_type], ["Progress", FileManagementProgress_$reflection()]]);
}

export class FileDownload extends Record {
    constructor(Name) {
        super();
        this.Name = Name;
    }
}

export function FileDownload_$reflection() {
    return record_type("RAWMap.Client.FileManagement.Types.FileDownload", [], FileDownload, () => [["Name", string_type]]);
}

export class StringDisplays extends Record {
    constructor(DeleteWarning) {
        super();
        this.DeleteWarning = DeleteWarning;
    }
}

export function StringDisplays_$reflection() {
    return record_type("RAWMap.Client.FileManagement.Types.StringDisplays", [], StringDisplays, () => [["DeleteWarning", string_type]]);
}

export class FileManagementViewModel extends Record {
    constructor(MaybeFileData, Name, MaybeManagedUpload, Progress) {
        super();
        this.MaybeFileData = MaybeFileData;
        this.Name = Name;
        this.MaybeManagedUpload = MaybeManagedUpload;
        this.Progress = Progress;
    }
}

export function FileManagementViewModel_$reflection() {
    return record_type("RAWMap.Client.FileManagement.Types.FileManagementViewModel", [], FileManagementViewModel, () => [["MaybeFileData", option_type(FileData_$reflection())], ["Name", string_type], ["MaybeManagedUpload", option_type(class_type("Fable.Import.Aws.S3.ManagedUpload"))], ["Progress", FileManagementProgress_$reflection()]]);
}

export class FileHandling extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Normal", "ZipBatch"];
    }
}

export function FileHandling_$reflection() {
    return union_type("RAWMap.Client.FileManagement.Types.FileHandling", [], FileHandling, () => [[], []]);
}

export class Model extends Record {
    constructor(Specs, DisplayContent, Message, FileHandling, UploadSelection, FailedUploads, FileManagementsInProgress, PersistedFiles, DownloadableFiles, MaybeS3VmsToDelete, SignedUrls, OperationContext) {
        super();
        this.Specs = Specs;
        this.DisplayContent = DisplayContent;
        this.Message = Message;
        this.FileHandling = FileHandling;
        this.UploadSelection = UploadSelection;
        this.FailedUploads = FailedUploads;
        this.FileManagementsInProgress = FileManagementsInProgress;
        this.PersistedFiles = PersistedFiles;
        this.DownloadableFiles = DownloadableFiles;
        this.MaybeS3VmsToDelete = MaybeS3VmsToDelete;
        this.SignedUrls = SignedUrls;
        this.OperationContext = OperationContext;
    }
}

export function Model_$reflection() {
    return record_type("RAWMap.Client.FileManagement.Types.Model", [], Model, () => [["Specs", FileComponentSpecs_$reflection()], ["DisplayContent", StringDisplays_$reflection()], ["Message", string_type], ["FileHandling", FileHandling_$reflection()], ["UploadSelection", list_type(FileData_$reflection())], ["FailedUploads", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, FileManagementViewModel_$reflection()])], ["FileManagementsInProgress", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, FileManagementViewModel_$reflection()])], ["PersistedFiles", list_type(S3ObjectViewModel_$reflection())], ["DownloadableFiles", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, FileManagementViewModel_$reflection()])], ["MaybeS3VmsToDelete", option_type(list_type(S3ObjectViewModel_$reflection()))], ["SignedUrls", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, string_type])], ["OperationContext", FileOperationContext_$reflection()]]);
}

export class LocalMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Noop", "ExnErrorMsg", "ShowErrorToast", "ListS3Objects", "GotListS3ObjectsOutput", "ValidateFiles", "UploadSelectionChanged", "TriggerUploads", "MakeUploadObjects", "UploadFile", "AbortUpload", "AbortSuccess", "UploadCompleted", "UploadFailed", "GotProgress", "GetPresignedUrl", "GotPresignedUrl", "PromptS3Delete", "CancelDeleteFromS3", "DeleteFromS3", "GotS3DeleteOutput", "RetryFailedUpload", "CancelFailedUpload"];
    }
}

export function LocalMsg_$reflection() {
    return union_type("RAWMap.Client.FileManagement.Types.LocalMsg", [], LocalMsg, () => [[], [["Item", class_type("System.Exception")]], [["Item", string_type]], [], [["Item", class_type("Fable.Import.Aws.S3.ListObjectsV2Output")]], [["fileDataList", list_type(FileData_$reflection())], ["onSuccess", lambda_type(Model_$reflection(), tuple_type(Model_$reflection(), list_type(lambda_type(lambda_type(LocalMsg_$reflection(), unit_type), unit_type)), list_type(lambda_type(lambda_type(OutboundMsg_$reflection(), unit_type), unit_type))))]], [["Item1", list_type(FileData_$reflection())], ["triggerUpload", bool_type]], [["Item", list_type(FileData_$reflection())]], [["Item", list_type(FileData_$reflection())]], [["Item1", class_type("Fable.Import.Aws.S3.ManagedUpload")], ["fileName", string_type]], [["fileName", string_type]], [["Item", unit_type]], [["fileName", string_type], ["Item2", class_type("Fable.Import.Aws.S3.ManagedUploadModule.SendData")]], [["fileName", string_type], ["Item2", class_type("System.Exception")]], [["fileName", string_type], ["Item2", FileManagementProgress_$reflection()]], [["Item1", enum_type("RAWMap.Client.Common.AwsCommon.DownloadBehavior", int32_type, [["Normal", 0], ["OpenNewWindow", 1]])], ["fileName", string_type]], [["fileName", string_type], ["url", string_type]], [["Item", list_type(S3ObjectViewModel_$reflection())]], [], [["Item", list_type(S3ObjectViewModel_$reflection())]], [["fileNames", list_type(string_type)], ["Item2", class_type("Fable.Import.Aws.S3.DeleteObjectsOutput")]], [["fileName", string_type]], [["fileName", string_type]]]);
}

export class OutboundMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["DownloadableFilesUpdated", "ValidSelectionUpdated", "UploadStarted", "UploadCompleted", "UploadFailed", "FileDeleted"];
    }
}

export function OutboundMsg_$reflection() {
    return union_type("RAWMap.Client.FileManagement.Types.OutboundMsg", [], OutboundMsg, () => [[], [], [], [], [], []]);
}

export class InboundMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["RefreshFileList", "UpdateUploadSelection", "UpdateFileHandling"];
    }
}

export function InboundMsg_$reflection() {
    return union_type("RAWMap.Client.FileManagement.Types.InboundMsg", [], InboundMsg, () => [[], [["Item", UploadSelection_$reflection()]], [["Item", FileHandling_$reflection()]]]);
}

export function StringDisplays_get_defaults() {
    return new StringDisplays("Are you sure you want to delete this file? This operation can not be undone.");
}

export function FileManagementViewModel_abortUpload_27E04A4D(fileManagementVm) {
    iterate((u) => {
        u.abort();
    }, toArray(fileManagementVm.MaybeManagedUpload));
}

export function Model_getNumberOfAssociatedFiles_Z379152CB(model) {
    return sum(ofArray([count(model.FileManagementsInProgress), count(model.DownloadableFiles), count(model.FailedUploads)]), {
        GetZero: () => 0,
        Add: (x, y) => (x + y),
    });
}

export function Model_getNumberOfNovelSelections_Z379152CB(model) {
    const associatedFileDataList = map((tupledArg) => tupledArg[1].MaybeFileData, List_distinct(concat([toList(model.FileManagementsInProgress), toList(model.DownloadableFiles), toList(model.FailedUploads)]), {
        Equals: equalArrays,
        GetHashCode: arrayHash,
    }));
    return length_1(filter((selected) => !contains(selected, associatedFileDataList, {
        Equals: equals,
        GetHashCode: structuralHash,
    }), model.UploadSelection)) | 0;
}

export function Model_tryTerminate_Z379152CB(model) {
    return ResultComputationExpression_ResultBuilder__Run_FCFD9EF(ResultComputationExpression_result, ResultComputationExpression_ResultBuilder__Delay_1505(ResultComputationExpression_result, () => ResultComputationExpression_ResultBuilder__Return_1505(ResultComputationExpression_result, () => {
        iterate_1((arg) => {
            FileManagementViewModel_abortUpload_27E04A4D(arg[1]);
        }, toList(model.FileManagementsInProgress));
    })));
}

export function FileList_mkFileSeq(files, i, last) {
    return delay(() => append(singleton(files[i]), delay(() => {
        if (i >= last) {
            return empty();
        }
        else {
            return FileList_mkFileSeq(files, i + 1, last);
        }
    })));
}

export function FileList_toSeq(files) {
    const matchValue = files.length | 0;
    if (matchValue === 0) {
        return empty();
    }
    else {
        return FileList_mkFileSeq(files, 0, matchValue - 1);
    }
}

